// src/components/layout/Sidebar.js
import React from 'react';
import { Nav } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../contexts/AuthContext';
import { useData } from '../../contexts/DataContext';
import { hasPermission } from '../../utils/permissions';
import { sidebarGroups } from './sidebarGroups';
import { PERMISSIONS } from '../../utils/permissions'; // Import PERMISSIONS if needed directly
import '../../styles/Sidebar.css';

const Sidebar = ({ isVisible }) => {
    const { t } = useTranslation();
    const { user } = useAuth();
    const { rolesPermissionsMap } = useData();
    const groups = sidebarGroups(t);

    const canView = (permission) => hasPermission(user?.role, permission, rolesPermissionsMap);

    // Base classes - removed text-white
    const linkClasses = `nav-link d-flex align-items-center sidebar-link`;
    const getNavLinkClass = ({ isActive }) => isActive ? `${linkClasses} active` : linkClasses;

    return (
        <div className={`sidebar-component d-flex flex-column flex-shrink-0 ${isVisible ? 'show' : 'hide'}`} >
            {/* Logo/Brand - removed text-white */}
            <NavLink
                 to="/dashboard"
                 className="d-flex align-items-center text-decoration-none app-brand" // Use class from CSS
             >
                 <img src="/logo192.png" alt={t('appName')} width="30" height="30" className="me-2"/> 
                 {t('appName')}
             </NavLink>
            <hr className="mt-0 mb-2"/>

            {/* Iterate over Groups */}
            <Nav variant="pills" className="flex-column mb-auto" as="ul">
                {groups.map((group, groupIndex) => (
                    <React.Fragment key={`group-${groupIndex}`}>
                        {group.titleKey && (
                             <li className="nav-item mt-2 mb-1 px-3"> {/* Added more padding */}
                                <span className="sidebar-group-title">
                                    {t(group.titleKey)}
                                </span>
                            </li>
                        )}
                        {group.items.map((item, itemIndex) => (
                            canView(item.permission) && (
                                <Nav.Item as="li" key={`item-${groupIndex}-${itemIndex}`} className="mb-1 px-2"> {/* Added padding */}
                                    <NavLink to={item.to} className={getNavLinkClass}>
                                        <item.icon className="sidebar-icon" />
                                        <span className="sidebar-text">{t(item.labelKey)}</span>
                                    </NavLink>
                                </Nav.Item>
                            )
                        ))}
                    </React.Fragment>
                ))}
            </Nav>
        </div>
    );
};

export default Sidebar;